<template>
  <div id="app">
    <food-list></food-list>
  </div>
</template>

<script>
import FoodList from './components/FoodList.vue'

export default {
  name: 'App',
  components: {
    FoodList,
  }
}
</script>

<style>
body {
  margin:0;
}
</style>
